import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
`;

export const Label = styled.div`
  font-size: 13px;
  line-height: 18px;
`;
